'use strict';

exports.Mid = require('@mid/sdk').Mid;
exports.Widget = require('./dist/reactRedirectWidget').ReactRedirectWidget;
exports.LoginComponent = require('./dist/components/react/redirect/login').default;
